import React from 'react'
import { InputGuesser } from '@api-platform/admin'
import {
  required,
  minLength,
  PasswordInput,
  CheckboxGroupInput,
  usePermissions,
  SelectInput,
} from 'react-admin'

import { roleOptions } from '../../mixin/user'
import { EditGuesser } from '../../theme/components'

export const UserEdit = (props) => {
  const { permissions } = usePermissions()

  if (!permissions) {
    return null
  }

  return (
    <EditGuesser{...props}>
      <InputGuesser source="email" inputProps={{ autoComplete: 'email' }} />
      <InputGuesser source="firstName" inputProps={{ autoComplete: 'off' }} />
      <InputGuesser source="lastName" inputProps={{ autoComplete: 'off' }} />
      <CheckboxGroupInput
        source="roles"
        choices={roleOptions(permissions)}
        validate={[required()]}
      />
      <SelectInput
        source="language"
        validate={[required()]}
        choices={[
          { id: 'NL', name: 'Dutch' },
          { id: 'EN', name: 'English' },
        ]}
      />
      <InputGuesser source="active" />
      <PasswordInput
        label="Password"
        source="plainPassword"
        inputProps={{ autoComplete: 'no' }}
        validate={[minLength(8, `Check if password is not less then 8 characters long`)]}
      />
    </EditGuesser>
  )
}
